import { Resource } from "../resource";

export class NameIdItem extends Resource {
    name: string
}
export class PasswordRestore extends Resource {
    personalId: string
    token: string
    password: string
}